import React from 'react';
import { ActionLink } from './ActionLink';
import './ActionLinks.less';
import { hasNesting } from './utils/ActionLinksUtils';
import { IActionLinksModel, IActionLinkItems, IActionLinkItem } from './ActionLinkModels';
import { IActionHoverHandler, ShowsNestedOnHover } from './hooks/ShowsNestedOnHover';
import { ActionLinkGroup } from './ActionLinkGroup';
import { ActionLinkSeam } from './ActionLinkSeam';
import { Placement } from 'popper.js';

export interface IActionLinksProps extends IActionLinksModel {
  values: IActionLinkItems;
  callback?: (value: any) => void;
  level?: number;
  placement?: Placement;
  /** */
  afterLabels?: (linkProps: IActionLinkItem) => React.ReactNode;
  extraValues?: IActionLinkItems[];
  onHover?: IActionHoverHandler;
  dividerForGroups?: boolean;
}

/**
 * Action Links to show a set of actions.
 *
 * This isn't robust yet, as it is mostly necessary for Mapping Type Selectors within the Property Grid, currently.
 *
 * Copyright (c) 2019 Decisions All Rights Reserved
 */
export function ActionLinks(props: IActionLinksProps) {
  const {
    callback,
    placement,
    values,
    afterLabels,
    translateLabels,
    extraValues,
    onHover,
    dividerForGroups = true,
  } = props;
  const { nestingLevel, hoveredLabel, nestedKeys, mouseOver, onNeighborHover } = ShowsNestedOnHover({
    ...props,
    onHover,
  });

  return (
    <>
      {values.current &&
        values.current.map((item, i) => {
          const { label, onClick = callback, isSeam, ...rest } = item;
          return isSeam ? (
            <ActionLinkSeam />
          ) : (
            <ActionLink
              key={label + i}
              label={label}
              onClick={onClick}
              onMouseOver={mouseOver}
              afterLabel={afterLabels?.(item)}
              translateLabel={translateLabels}
              {...rest}
            />
          );
        })}
      {hasNesting(values) && dividerForGroups && <ActionLinkSeam />}
      {hasNesting(values) &&
        nestedKeys.map(key => (
          <ActionLinkGroup
            key={key}
            groupLabel={key}
            values={values.nested!.get(key)}
            callback={callback}
            level={nestingLevel + 1}
            onMouseOver={mouseOver}
            hoveredLabel={hoveredLabel}
            direction={placement}
            afterLabels={afterLabels}
            translateLabels={translateLabels}
          />
        ))}
      {extraValues && (
        <>
          {extraValues.map((links, i) => (
            <React.Fragment key={i}>
              <ActionLinkSeam />
              <ActionLinks {...props} values={links} extraValues={undefined} onHover={onNeighborHover} />
            </React.Fragment>
          ))}
        </>
      )}
    </>
  );
}

/* <ActionLink key={key} value={key} label={key} onMouseOver={mouseOver} />
{hoveredLabel === key && (
  <ActionLinks key={key + 1} level={nestingLevel + 1} values={value} callback={callback} />
)} */
